import React, { FC } from "react";
import { StyleSheet, View } from "@react-pdf/renderer";

import { DatesSection } from "./DatesSection";
import { DocumentWrapper, Footer, Header } from "../common";
import { CardSidedLayout } from "../layouts";
import { PaymentRequest } from "../../../types/PaymentRequestTypes";
import { SummarySection } from "./SummarySection";
import { CURRENCY_MAP } from "../../../constants";

type Props = {
  data: PaymentRequest;
};

const styles = StyleSheet.create({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: 24,
  },
});

export const PDFPaymentRequest: FC<Props> = ({ data }) => {
  const {
    payer_name,
    created_at,
    paid_at,
    currency,
    outgoing_currency,
    amount,
    transaction_details,
  } = data;

  const { price, tds_amount, outgoing_amount_after_tds } = transaction_details;

  const incomingCurrency = CURRENCY_MAP[currency];
  const outgoingCurrency = CURRENCY_MAP[outgoing_currency];

  return (
    <DocumentWrapper header={<Header title="Receipt" />} footer={<Footer />}>
      <View style={styles.wrapper}>
        <DatesSection
          exchangeDate={created_at.toString()}
          paymentDate={paid_at?.toString()}
        />

        <CardSidedLayout
          left={{
            label: "From payer",
            value: payer_name,
          }}
          right={{
            label: "To me",
            value: "Me",
          }}
        />

        <SummarySection
          sent={{
            currency: incomingCurrency.symbol,
            value: amount,
          }}
          exchangeRate={{
            currency: outgoingCurrency.symbol,
            value: price,
          }}
          endOfTheYear={{
            currency: outgoingCurrency.symbol,
            value: tds_amount,
          }}
          receiveNow={{
            currency: outgoingCurrency.symbol,
            value: outgoing_amount_after_tds,
          }}
        />
      </View>
    </DocumentWrapper>
  );
};
